import { useApiQuery } from '@/hooks/react-query/useApiQuery';
import { portalQueryKeys } from '@/portal/shared/hooks/queryKeys';
import { investorPortalApiClient } from '@/portal/shared/utils/api-client';
import {
  mapHoldingsSummary,
  mapFundHoldingResponse,
} from '../portalHoldingsMapper';
import type {
  FundHolding,
  HoldingsSummary,
  RawFundHolding,
  RawHoldingsSummary,
} from '../types';

export type { FundHolding, HoldingsSummary };

export const useHoldings = () => {
  return useApiQuery<HoldingsSummary>(
    portalQueryKeys.holdings.summary(),
    async () => {
      const raw =
        await investorPortalApiClient.get<RawHoldingsSummary>(
          '/portal/holdings'
        );
      return mapHoldingsSummary(raw);
    },
    {
      staleTime: 2 * 60 * 1000,
    }
  );
};

export const useFundHoldings = (fundId: string | undefined) => {
  return useApiQuery<FundHolding>(
    portalQueryKeys.holdings.byFund(fundId),
    async () => {
      const raw = await investorPortalApiClient.get<RawFundHolding>(
        `/portal/holdings/funds/${fundId}`
      );
      return mapFundHoldingResponse(raw);
    },
    {
      enabled: !!fundId,
      staleTime: 2 * 60 * 1000,
    }
  );
};
